__webpack_require__.p = "/React_MiniGames/";